/**
 * Simple focus trap utility class (mainly for use in megamenu in the header-navigation)
 * Use it like this: new TrapFocus(document.getElementById('id of the container'))
 * More info here - https://codepen.io/massimo-baffoni/pen/mdjXXeg
 */
export class TrapFocus {
  constructor(element) {
    this.container = element
    this.focusableEls = []
    this.FOCUSABLES = 'a[href]:not([disabled]), area[href]:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]'
    this.setFocusables()
    this.setEventListeners()
  }

  setFocusables() {
    this.focusableEls = this.container.querySelectorAll(this.FOCUSABLES)
  }

  setEventListeners() {
    this.container.addEventListener('keydown', this.keyboardHandler)
    this.container.setAttribute('tabindex', '-1')
    //commenting out this row since it stops selecting text in the megamenu. We do not need focusRebounce at this stage.
    //this.container.addEventListener('focus', this.focusRebounce)
  }

  /* Listener relative to keypress, to let focus cycle inside container elements andnot outside */
  keyboardHandler = (e) => {
    if (e.key === 'Tab' || e.keyCode === 9) {
      if (e.shiftKey && e.target === this.focusableEls[0]) {
        e.preventDefault()
        this.focusableEls[this.focusableEls.length - 1].focus()
      } else if (!e.shiftKey && e.target === this.focusableEls[this.focusableEls.length - 1]) {
        e.preventDefault()
        this.focusableEls[0].focus()
      }
    }
  }

  /* Utility listener, not needed for theoverall logics but potentially useful for automatically targeting the first focusable element from outside container. This is a requested behaviour for modals and dropdowns */
  focusRebounce = () => {
    this.focusableEls[0].focus()
  }
}
